"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class QuestionAnswerOption {
    constructor() {
        this.options = {};
    }
    getValue() {
        return this.value;
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    getLabel() {
        return this.label;
    }
    setLabel(label) {
        this.label = label;
        return this;
    }
    getDescription() {
        return this.description;
    }
    setDescription(description) {
        this.description = description;
        return this;
    }
    getWeight() {
        return this.weight;
    }
    setWeight(value) {
        this.weight = value;
        return this;
    }
    getOptions() {
        return this.options;
    }
    setOptions(options) {
        this.options = options || {};
        return this;
    }
    getOptionalTooltip() {
        const tooltip = this.getOptions().tooltip;
        return tooltip !== undefined ? tooltip : null;
    }
    getOptionalClassName() {
        const className = this.getOptions().cssClass;
        return className !== undefined ? className : '';
    }
}
exports.default = QuestionAnswerOption;
